import { openBrowser } from "@/lib/urlUtils";

export const LOCAL_OBJECT_STORAGE_PROXY_PREFIX = "/local-minio";

const LOCAL_OBJECT_STORAGE_HOSTS = new Set(["localhost", "127.0.0.1"]);
const LOCAL_OBJECT_STORAGE_PORT = "9000";

export function isLocalObjectStoragePdfUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    return LOCAL_OBJECT_STORAGE_HOSTS.has(parsed.hostname) && parsed.port === LOCAL_OBJECT_STORAGE_PORT;
  } catch {
    return false;
  }
}

export function localObjectStorageProxyPath(url: string): string {
  const parsed = new URL(url);
  return `${LOCAL_OBJECT_STORAGE_PROXY_PREFIX}${parsed.pathname}${parsed.search}`;
}

export function careerPlanPdfFilename(url: string): string {
  try {
    const segment = new URL(url).pathname.split("/").filter(Boolean).at(-1);
    if (segment?.toLowerCase().endsWith(".pdf")) {
      return decodeURIComponent(segment);
    }
  } catch {
    // Fall through to the default name.
  }
  return "career-plan.pdf";
}

function downloadBlob(blob: Blob, filename: string) {
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = filename;
  link.rel = "noopener";
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(objectUrl);
}

export async function openCareerPlanPdf(url: string): Promise<void> {
  if (!isLocalObjectStoragePdfUrl(url)) {
    openBrowser(url);
    return;
  }

  const response = await fetch(localObjectStorageProxyPath(url));
  if (!response.ok) {
    throw new Error(`Career plan PDF download failed (${response.status})`);
  }

  downloadBlob(await response.blob(), careerPlanPdfFilename(url));
}
